import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetChannelsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/get-channels-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterChannelListContext } from '../../channel-list.context';
import { ChannelListFilterFormStep1Controller } from '../channel-list-filter-form-step-1/channel-list-filter-form-step-1.controller';

export interface ChannelListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetChannelsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetChannelsPaginatedModel>;
  onCancel: () => void;
}

export const ChannelListFilterFormController = (
  props: ChannelListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterChannelListContext();

  return (
    <MultiStepFormProvider<GetChannelsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      items={[
        {
          fields: [
            'isOnline',
            'isMaintenance',
            'lastMessageReceivedDate',
            'customerId',
            'locationId',
            'networkId',
            'tariffId',
          ],
          component: <ChannelListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
